import React from "react";
import { Link } from "react-router-dom";
import style from '../styles/nav.module.css'

export default function NavBar() {
    return (

        <nav className={style.main_container_nav}>
            <div className={style.nav_content}>
                <div className={style.nav_title}>
                    <h2>A/CC</h2>
                </div>
                <div className={style.nav_btns}>
                    <Link to={'/Home'} >
                        <button><i class="bi bi-house-fill" />&nbsp;Home</button>
                    </Link>

                    <Link to={'/Create'} >
                        <button><i class="bi bi-box-arrow-right" />&nbsp;Creator</button>
                    </Link>

                    <Link to={'/About'} >
                        <button><i class="bi bi-person-lines-fill" />&nbsp;About</button>
                    </Link>
                </div>
            </div>
        </nav >

    )
}